import { useMemo } from 'react';
import { Text } from '~/components/ui/Text';
import { rage, useObservable } from '~/rage';
import { isClothesItem, RewardType } from '~/shared';
import { ShopPlayerItem } from '../ShopPlayerItem';
import {
	StyledContainer,
	StyledEmptyContainer,
} from './ShopPlayerItems.styled';

const ShopPlayerItems = () => {
	const donateItems = useObservable(rage.inventoryDonate.getDonateOwnedItems());
	const itemsCount = useObservable(rage.inventoryDonate.getItemsCount());
	const lootboxes = useObservable(rage.cases.getLootboxes());

	const isEmpty = useMemo(() => itemsCount === 0, [itemsCount]);

	if (isEmpty) {
		return (
			<StyledEmptyContainer>
				<Text>
					К сожалению,
					<br />у вас нет предметов
				</Text>
			</StyledEmptyContainer>
		);
	}

	return (
		<StyledContainer>
			{donateItems.map((item, index) => {
				const rewardType = rage.inventoryDonate.getTypeById(item.id);
				let imageId = rage.cases.getRewardImageId(item.id) ?? item.id;
				if (rewardType === RewardType.LOOTBOX) {
					const lootbox =
						lootboxes.find((x) => x.donateItemId === item.id) ??
						lootboxes.find((x) => x.id === item.id);

					imageId = lootbox?.id ?? imageId;
				}
				const name = rage.cases.getRewardNameById(item.id);

				if (
					rewardType === RewardType.VEHICLE ||
					rewardType === RewardType.LOOTBOX
				) {
					return (
						<ShopPlayerItem
							type={rewardType}
							name={name}
							id={item.id}
							imageId={imageId}
							count={item.count}
							key={`${item.id}-${index}`}
						/>
					);
				}
				if (rewardType === RewardType.ITEM || isClothesItem(imageId)) {
					return (
						<ShopPlayerItem
							type={RewardType.ITEM}
							name={name}
							id={item.id}
							imageId={imageId}
							count={item.count}
							key={`${item.id}-${index}`}
						/>
					);
				}
				if (rewardType === RewardType.EXP || rewardType === RewardType.MONEY) {
					return (
						<ShopPlayerItem
							type={rewardType}
							name={name}
							id={item.id}
							count={item.count}
							key={`${item.id}-${index}`}
						/>
					);
				}

				return null;
			})}
		</StyledContainer>
	);
};

export { ShopPlayerItems };
